import { render } from "./Scene.vue?vue&type=template&id=ad8d8348&scoped=true"
import script from "./Scene.vue?vue&type=script&lang=ts"
export * from "./Scene.vue?vue&type=script&lang=ts"

import "./Scene.vue?vue&type=style&index=0&id=ad8d8348&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ad8d8348"

export default script